import React, { Component } from "react";
import PropTypes from "prop-types";
import firebase from 'firebase/compat/app';
import "../../../common/firebase";
import "firebase/auth";

class TwitterLink extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isRequesting: false,
      isTwitterLinked: Boolean(props.twitter_url),
      isTwitterButtonHover: false,
    };
  }

  toggleTwitterButtonHover = () => {
    this.setState(prevState => ({
      isTwitterButtonHover: !prevState.isTwitterButtonHover
    }));
  }

  handleTwitterLinkClick = (event) => {
    event.preventDefault();

    this.setState({isRequesting: true});

    const { isTwitterLinked } = this.state;
    const provider = new firebase.auth.TwitterAuthProvider();

    firebase.auth().signInWithPopup(provider)
      .then((response) => {
        if (isTwitterLinked) {
          this.requestTwitterUnlink();
        } else {
          this.requestTwitterCallback(response);
        }
      }).catch(() => {
        this.setState({isRequesting: false});
      });
  }

  requestTwitterCallback = (response) => {
    const params = {
      uid: response.additionalUserInfo.profile.id,
      screen_name: response.additionalUserInfo.username,
      profile_image_url: response.additionalUserInfo.profile.profile_image_url_https,
      access_token: response.credential.accessToken,
      access_token_secret: response.credential.secret
    };

    const { actions } = this.props;
    actions.postTwitterCallback(params).then(() => {
      this.setState(prevState => ({
        isRequesting: false,
        isTwitterLinked: !prevState.isTwitterLinked,
      }));
    }).catch(() => {
      this.setState({isRequesting: false});
    });
  }

  requestTwitterUnlink = () => {
    const { actions } = this.props;
    actions.deleteTwitterLink().then(() => {
      this.setState(prevState => ({
        isRequesting: false,
        isTwitterLinked: !prevState.isTwitterLinked,
      }));
    }).catch(() => {
      this.setState({isRequesting: false});
    });
  }

  render () {
    const { isRequesting, isTwitterLinked, isTwitterButtonHover } = this.state;

    return (
      <div className="form-group row">
        <label className="col-6" htmlFor="twitter-link">
          <i className="fab fa-twitter pr-2" />
          Twitter
        </label>
        <div className="col-6 text-right">
          { isRequesting === true ? (
            <input type="button" className="btn btn-outline-secondary" value="接続中..." disabled />
          ) : (
            <input
              id="twitter-link"
              type="button"
              className={`btn ${isTwitterLinked ? "btn-primary" : "btn-outline-primary" }`}
              onClick={this.handleTwitterLinkClick}
              value={isTwitterLinked ? (isTwitterButtonHover ? "連携解除" : "連携済み") : "連携する"}
              onMouseEnter={this.toggleTwitterButtonHover}
              onMouseLeave={this.toggleTwitterButtonHover}
            />
          )}
        </div>
      </div>
    );
  }
}

TwitterLink.propTypes = {
  twitter_url: PropTypes.string,
  actions: PropTypes.objectOf(PropTypes.func).isRequired
};

TwitterLink.defaultProps = {
  twitter_url: null
};

export default TwitterLink;
